import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

import { Dropdown } from './../../models/editors/dropdown.model';
import { BookingHoliday, BookingOffer } from './../../models/bookings/bookings.model';
import { DatePicker } from './../../models/editors/datepicker.model';



@Component({
  selector: 'swb-booking-holiday-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class BookingHolidayDetailComponent extends FormDetailBase<BookingHoliday> implements OnInit, OnDestroy {

  private _booking_offer_id: number;

  public url = 'booking-holidays';

  protected _redirect = './bookings';

  public entity = new BookingHoliday({});
  public bookings: Array<BookingOffer> = [];

  public get fieldsConfig(): Array<any> {
    return [
      new Dropdown({
        key: 'booking_offer_id',
        label: 'Rezervační nabídka',
        options: this._formService.getDropdownValues('title', this.bookings),
        defaultValue: this._booking_offer_id ? this._booking_offer_id : (this.bookings[0] ? this.bookings[0].id : null)
      }),
      new DatePicker({
        key: 'date_from',
        label: 'Od'
      }),
      new DatePicker({
        key: 'date_to',
        label: 'Do'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {


    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (typeof this._route.snapshot.params['booking_offer_id'] !== 'undefined') {
      this._booking_offer_id = parseInt(this._route.snapshot.params['booking_offer_id'], 10);
    }

    this._getBookingsList();

  }

  protected _setupForm(): void {
    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.entity);
    this.formEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.entity);
    this.isInitialized = true;

  }

  public ngOnDestroy(): void {
    // TODO: do something
  }

  private _getBookingsList() {
    this._apiService.get('booking-offers/list')
      .subscribe(
        (response: any) => {
          this.bookings = { ...response }.data;
          this._getEntity();
        },
        (error) => console.error(error)
      );
  }

}
